import styled from '@emotion/styled';
import { colors } from 'constants/colors';

export const GraphicContainer = styled('div')({
  width: '100%',
  backgroundColor: colors.WHITE,
  paddingTop: 10,
  borderRadius: '13px',
});
